export default __webpack_public_path__ + "static/media/SuggestionItemSearchPin.9d2e9435.svg";